// Client preference: whether we emit typing ephemeral frames.

const STORAGE_KEY = 'ping.privacy.showTypingIndicators';

let cached: boolean | null = null;

export function getShowTypingIndicators(): boolean {
  if (cached !== null) return cached;
  if (typeof localStorage === 'undefined') {
    return true;
  }
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === null) {
    cached = true;
    return true;
  }
  cached = raw === '1' || raw === 'true';
  return cached;
}

export function setShowTypingIndicators(enabled: boolean): void {
  cached = enabled;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  }
}
